import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { BdCompanyContextService } from '@bindoc-projects/bindoc-permissions-lib/data';
import {
  BdCompany,
  BdCompanyGroup,
} from '@bindoc-projects/resource-domain-lib';
import { take } from 'rxjs';

import { BdCompanySelectComponent } from '../company/company-select.component';
import { BdGroupSelectComponent } from '../group/group-select.component';
import { IftaLabel } from 'primeng/iftalabel';
import { InputText } from 'primeng/inputtext';

@Component({
  selector: 'bd-combined-group-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col gap-3">
      @if (lockedCompany()) {
        <p-ifta-label>
          <input
            id="combined-group-select-company-form"
            pInputText
            readonly
            fluid
            variant="filled"
            [value]="$safeNavigationMigration(lockedCompany()?.name)"
          />
          <label for="combined-group-select-company-form">Kunde</label>
        </p-ifta-label>
      } @else {
        <bd-company-select
          (companySelect)="onCompanySelect($event)"
        ></bd-company-select>
      }
      <bd-group-select
        [company]="company()"
        (groupSelect)="onGroupSelect($event)"
      ></bd-group-select>
    </div>
  `,
  imports: [
    BdCompanySelectComponent,
    BdGroupSelectComponent,
    IftaLabel,
    InputText,
  ],
})
export class BdCombinedGroupSelectComponent implements OnInit {
  public readonly groupSelect = output<BdCompanyGroup>();

  public readonly company = signal<BdCompany | undefined>(undefined);
  public readonly lockedCompany = signal<BdCompany | undefined>(undefined);

  private readonly _companyContext = inject(BdCompanyContextService);

  ngOnInit(): void {
    this._companyContext.selectedCompany$.pipe(take(1)).subscribe((c) => {
      if (c) {
        this.lockedCompany.set(c);
        this.company.set(c);
      }
    });
  }

  public onCompanySelect(company: BdCompany): void {
    this.company.set(company);
  }

  public onGroupSelect(group: BdCompanyGroup): void {
    this.groupSelect.emit(group);
  }
}
